import React, { useState } from 'react';
import './App.css';
import TopicInput from './components/TopicInput';
import PresentationViewer from './components/PresentationViewer';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const [presentation, setPresentation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGenerate = async (topic) => {
    setIsLoading(true);
    setError(null);
    setPresentation(null);

    try {
      const apiUrl = process.env.REACT_APP_API_URL || '/api';
      const response = await fetch(`${apiUrl}/presentation/generate`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ topic, slideCount: 15 }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to generate presentation');
      }

      const data = await response.json();
      setPresentation(data);
    } catch (err) {
      setError(err.message || 'An error occurred while generating the presentation');
      console.error('Error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    setPresentation(null);
    setError(null);
  };

  if (presentation) {
    return <PresentationViewer presentation={presentation} onReset={handleReset} />;
  }

  return (
    <div className="app">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <TopicInput onGenerate={handleGenerate} error={error} />
      )}
    </div>
  );
}

export default App;
